// Auth0 Dev item D: where a logged-out visitor was going, kept across the
// login so they land on that page afterwards (legacy and Auth0 alike).
import { AUTH_ROUTE_PREFIX } from "./poSession";

const TARGET_KEY = "po_login_target";
const DEFAULT_TARGET = "/dashboard";

// A same-origin app path only; never an auth page, never another origin.
export function safeTarget(raw) {
  if (typeof raw !== "string" || !raw.startsWith("/") || raw.startsWith("//")) {
    return null;
  }
  try {
    const url = new URL(raw, window.location.origin);
    if (url.origin !== window.location.origin || url.pathname.startsWith(AUTH_ROUTE_PREFIX)) {
      return null;
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch (error) {
    return null;
  }
}

// True when the path is a real page in one of the signed-in routers, i.e. it
// does not fall through to that router's "*" Error route.
export function isAppRoute(path, routers) {
  return routers.some(r => {
    const matched = r.resolve(path).route.matched;
    const last = matched[matched.length - 1];
    return !!last && last.path !== "*";
  });
}

export function rememberLoginTarget(fullPath) {
  const target = safeTarget(fullPath);
  if (!target) return;
  try {
    sessionStorage.setItem(TARGET_KEY, target);
  } catch (error) {
    // Storage unavailable: the visitor lands on the dashboard instead.
  }
}

export function takeLoginTarget() {
  let raw = null;
  try {
    raw = sessionStorage.getItem(TARGET_KEY);
    sessionStorage.removeItem(TARGET_KEY);
  } catch (error) {
    raw = null;
  }
  return safeTarget(raw) || DEFAULT_TARGET;
}
